import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PopoverController} from '@ionic/angular';

@Component({
  selector: 'app-header-text-modal',
  templateUrl: './header-text-popover.component.html',
  styleUrls: ['./header-text-popover.component.scss']
})
export class HeaderTextPopoverComponent implements OnInit {
  @Input() text: string;
  @Input() title: string;

  constructor(private popoverController: PopoverController) { }

  ngOnInit() {
  }

  public get hasTitle(): boolean {
    return this.title != null && this.title.length > 0;
  }

  public get hasText(): boolean {
    return this.text != null && this.text.length > 0;
  }

  public close() {
    this.popoverController.dismiss();
  }
}
